import { GuiaDTO } from "./guia";
import { DireccionDTO } from "./direccion";
import { models } from "app/main/std";

/**Status del viaje de ZE. El proceso es el siguiente. El numero es el status del proceso: */
export enum StatusViajeZE {
    /**Ya se le asignó un destino y un chofer a ese camión, pero que el camión aún no esta en camino */
    Creado = 0,

    /**El camión ya salió */
    EnTrayecto = 1,

    /**El viaje ya volvió a la sucursal */
    Finalizado = 2,

    /**El viaje fue cancelado antes de ser iniciado.  */
    Cancelado = 3,

    /**El viaje fue cancelado despues de ser iniciado */
    CanceladoEnTrayecto = 4,

    /**El viaje fue iniciado en la app */
    IniciadoApp = 5,

    FinalizadoAppMovil = 6,

    FinalizadoPendienteDescarga = 7,

    PendienteVerificacion = 8
}

export interface ViajeZE {

    IdRegistro: number;

    Folio: number;

    /**Usuario que creó el viaje */
    IdUsuario: number;

    /**Id sucursal de salida del viaje */
    IdSucursal: number;

    /**Fecha real de creación del viaje */
    FechaCreacion: Date | string;

    /**
     * Fecha de inicio del viaje. Es lo mismo que la fecha de salida.
     * Al estar asignada esta fecha el status se considera como EnTrayecto
     */
    FechaInicio: Date | string | null;

    /**Fecha en la que el usuario finalizó el viaje en la app móvil. Al estar asignada esta fecha el status se considera como FinalizoAppMovil */
    FechaFinalizoAppMovil: Date | string | null;

    /**Fecha en la que el proceso de verificación y de selección de los acuses terminó. Este es el ultimo paso del proceso asi qu el status se considera Finalizado */
    FechaFinalizo: Date | string | null;

    /**Fecha en la que fue cancelado el viaje, si es que fue cancelado */
    FechaCancelacion: Date | string | null;

    /**
     * Fecha en la que el usuario de la parte web le da finalización al viaje despues de que el usuario de la parte móvil lo hace.
     * Al estar asignada esta fecha el status es FechaFinalizoPendienteDescarga. 
     */
    FechaLlegadaPendienteDescarga: Date | string | null;

    /**Fecha en la que el vehículo ya fue descargado por completo. Al estar asignada esta fecha el status del viaje es PendienteVerificacion */
    FechaPendienteVerificacion: Date | string | null;

    /**Chofer asignado a este viaje */
    IdChoferZE: number;

    /**Vehículo de ZE */
    IdVehiculoZE: number;

    /**Id del usuario que lo inició en la App */
    IdUsuarioViajeApp: number | null;

}

export interface ViajeZEDto extends ViajeZE {
    NombreUsuario: string;
    NombreSucursal: string;
    NombreChoferZE: string;
    NombreVehiculoZE: string;
    Status: StatusViajeZE;
    NombreProveedorZE: string;

    TieneXmlTimbrado: boolean;
    TienexmlImpreso: boolean;
}

export interface FiltroViajeZE {
    Folio?: number | null;
    IdSucursal?: number | null;
    FechaCreacionInicio?: Date | string | null;
    FechaCreacionFinal?: Date | string | null;
    IdChofer?: number | null;
    IdVehiculo?: number | null;
    IdProveedor?: number | null;
}


export interface FiltroCrearCargaZE {
    IdProveedor?: number | null;
    IdChofer?: number | null;
}

export interface NuevoViajeZEModel {
    IdChofer: number;
    IdVehiculoZE: number;
}

/**Contiene los datos que se le mostrarán al usuario para que este verifique un viaje de ZE finalizado */
export interface VerificacionViajeZEDto {

    /**Importe total pagado */
    ImporteTotal: number;

    /**Parte del importe total que no es el de crédito */
    ImporteContado: number;

    /**Parte del importe total que se pago en efectivo */
    ImporteEfectivo: number;

    /**Parte del importe total que se pago en cheque */
    ImporteCheque: number;

    /**Parte del importe que se paga de crédito */
    ImporteCredito: number;

    /**Guias que se entregaron y que tienen acuse ya sea interno o externo. Estos son los que debe de entregar el chofer */
    AcusesFirmados: GuiaDTO[];
    /**Guias que fueron entregadas en este viaje */
    GuiasEntregadas: GuiaDTO[];
    /**Guias que el cliente rechazó explicitamente */
    GuiasRechazadas: GuiaRechazadaZEDto[];
    /**Guias de las entregas en las que no se encontró al cliente */
    GuiasEntregaIncompleta: GuiaDTO[];

    /**Listado de las entregas donde no se pudo localizar al cliente */
    EntregasIncompletas: EntregaIncompletaZEDTO[];
}

export interface EntregaIncompletaZE {

    IdRegistro: number;

    /**Viaje en el que se intentó realizar esta entrega */
    IdViajeZE: number;
    ViajeZE: ViajeZE;

    /**Fecha en la que se realizó la entrega */
    FechaEntrega: Date | string;

    /**Motivo de la entrega incompleta */
    Motivo: string;

    /**Direccion de destino que fue visitada */
    IdDireccionCliente: number;
}

export interface EntregaIncompletaZEDTO extends EntregaIncompletaZE {
    NombreCliente: string;
    Direccion: DireccionDTO;
}

export interface GuiaRechazadaZEDto {
    IdRegistro: number;
    Folio: string;

    IdClienteOrigen: number;
    NombreClienteOrigen: string;

    IdSucursalOrigen: number;
    NombreSucursalOrigen: string;

    IdClienteDestino: number;
    NombreClienteDestino: string;

    IdSucursalDestino: number;
    NombreSucursalDestino: string;

    MotivoRechazo: string;
}


// WEBPACK FOOTER //
// ./app/models/viajeZe.ts